
import Vue from "vue";
import { GeneralPriceRule } from "@/models/base/general-price-rule";
import { GeneralPriceRuleService } from "@/services/general-price-rule-service";
import AppPriceRuleEditList from "@/components/price-rules/PriceRuleEditList.vue";
import { IBreadCrumb } from "winfakt-vue-components";
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";

export default Vue.extend({
	data(){
		return {
			toEditRule: null as GeneralPriceRule | null,
			rules: [] as GeneralPriceRule[]
		};
	},
	computed: {
		path(): IBreadCrumb[] {
			return [
				{
					to: "/settings/sales", value: this.$ct("sale/purchase")
				},
				{
					value: this.$ct("price-rules")
				}
			] as IBreadCrumb[];
		},
		newRuleConstructor():()=>GeneralPriceRule{
			return ()=>new GeneralPriceRule();
		}
	},
	methods: {
		async onSorted(){
			await GeneralPriceRuleService.setOrder(this.rules);
			await this.fetchRules();
		},
		async onRuleSaved(){
			await this.fetchRules();
		},
		async saveRule(rule:GeneralPriceRule):Promise<GeneralPriceRule>{
			if (rule.ID == 0){
				return GeneralPriceRuleService.createPriceRule(rule);
			}
			return GeneralPriceRuleService.updatePriceRule(rule);
		},
		async fetchRules(){
			let fetchedRules = await GeneralPriceRuleService.fetchPriceRules();
			fetchedRules.forEach(rule=>{
				let matchedRule = this.rules.find(r=>r.ID == rule.ID);
				if (!matchedRule) return;
				rule.key = matchedRule.key;
			});
			this.rules = fetchedRules;
		},
		async deleteRule(rule:GeneralPriceRule){
			await GeneralPriceRuleService.deletePriceRule(rule);
			await this.fetchRules();
		},
	},
	async mounted(){
		await this.fetchRules();
	},
	components: {
		AppMobileFullScreenContainer,
		AppPriceRuleEditList
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
